import React, { Dispatch, SetStateAction } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import InsightFiltersViewModel from "./ViewModels/InsightFiltersViewModel";
import InsightNameFilterContainer from "./Filters/FilterContainers/InsightNameFilterContainer";
import ChannelFilterContainer from "./Filters/FilterContainers/ChannelFilterContainer";
import ScheduleFilterContainer from "./Filters/FilterContainers/ScheduleFilterContainer";
import TimePeriodFilterContainer from "./Filters/FilterContainers/TimePeriodFilterContainer";
import ClientDisplayChip from "../Filtering/ReworkedFilters/Utility/ClientDisplay";
import DateFilterContainer from "./Filters/FilterContainers/DateFilterContainer";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AgentFilterContainer from "./Filters/FilterContainers/AgentFilterContainer";
import WeekNumberFilterContainer from "./Filters/FilterContainers/WeekNumberFilterContainer";
import TeamManagerFilterContainer from "./Filters/FilterContainers/TeamManagerFilterContainer";
import { InsightView } from "../ViewModels/InsightView";
interface IInsightTableFiltersProps {
    view: InsightView
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
    responseSearch: (newFilters?: InsightFiltersViewModel) => void
    setMatrixDialogOpen: (value: boolean) => void
}

export default function InsightTableFilters({ view, filters, setFilters, responseSearch, setMatrixDialogOpen }: IInsightTableFiltersProps) {
    const pageResetResponseSearch = () => {
        const newFilters = { ...filters }
        newFilters.pageNumber = 1
        setFilters(newFilters)

        responseSearch(newFilters);
    }

    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center" spacing={0} style={{ padding: '8px' }}>
                <Grid size={9}>
                    <Grid container spacing={1}>
                        <ClientDisplayChip name={filters.client} />
                        <ChannelFilterContainer filters={filters} setFilters={setFilters} />
                        <DateFilterContainer view={view} filters={filters} setFilters={setFilters} />
                        {view === InsightView.Agent && <AgentFilterContainer filters={filters} setFilters={setFilters} />}
                        <InsightNameFilterContainer view={view} filters={filters} setFilters={setFilters} />
                        <ScheduleFilterContainer filters={filters} setFilters={setFilters} />
                        <TimePeriodFilterContainer filters={filters} setFilters={setFilters} />
                        {(view === InsightView.Agent || view === InsightView.Operational) && <WeekNumberFilterContainer view={view} filters={filters} setFilters={setFilters} />}
                        {(view === InsightView.Agent || view === InsightView.Operational) && <TeamManagerFilterContainer view={view} filters={filters} setFilters={setFilters} />}
                    </Grid>
                </Grid>
                <Grid container justifyContent='flex-end' size={3}>
                    {filters.client !== "All" &&
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => setMatrixDialogOpen(true)}
                            sx={{ marginLeft: '8px', boxShadow: '0 0 0' }}>
                            <HelpOutlineIcon sx={{ marginRight: 1 }} /> Help
                        </Button>
                    }
                    <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        onClick={() => pageResetResponseSearch()}
                        sx={{ marginLeft: '8px', boxShadow: '0 0 0' }}>
                        Apply Filters
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};
